import { IFormStep } from "@rentiohq/web-shared-next/dist/utils/types/form";
import { uiSchema as uiSchema1 } from "./schema.addCustomMessage.1";
import { IExtraData } from "./schema.addCustomMessage.types";
import { getInitialValues } from "./schema.addCustomMessage.utils";

export const addCustomMessageSchema =
  (extraData: IExtraData) => (): { formStepsSchema: IFormStep[] } => {
    const formStepsSchema = [
      {
        uiSchema: uiSchema1(),
      },
    ];

    // @ts-ignore
    return { formStepsSchema, initialValues: getInitialValues(extraData) };
  };
